<div class="lvi-content">
    <div class="avatar">
        <span [translate]="'admin.bibliotheque.geographie.regions.avatar'"></span>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="goToDetailRegion()">{{ data.libelle }}</a>
        </div>
        <ul class="lvi-attrs">
            <li *ngIf="data.pays">
                <strong [translate]="'admin.bibliotheque.geographie.territoire.perimetre.pays'"></strong>
                <span *ngIf="data.pays.code2" class="flag-icon me-1" [ngClass]="'flag-icon-'+ data.pays.code2.toLowerCase()"></span>
                <span>{{ data.pays.libelle }}</span>
            </li>
        </ul>
    </div>
</div>